// extracted by mini-css-extract-plugin
export default {"quickMarcRecordInfoWrapper":"quickMarcRecordInfoWrapper---P9ZcR"};